import XhrRequestHandler from "../../lib/XhrRequestHandler";

export interface IMenuPermsssion{
  puxam_id?: string,
  puxam_perid: number
  puxam_codmenu: string,
  puxam_clienteid: string,
  puxam_activo: number
}

export interface IMenuInactivo{
  cod_menu: string,
  nombre_menu: string
}

export interface IPerfil {
  per_id: string;
  per_nombre: string;
}

export interface ICliente {
  cliente_id: string;
  cliente_nombre: string;
}

export interface IPerfilMenuAsignado {
  puxam_id: string;
  puxam_codmenu: string;
  puxam_perid: string;
  nombre_menu: string;
  puxam_activo: string;
  padre: string;
}

export interface IMenuPermisionRow {
  cod_menu: string;
  nombre_menu: string;
  menu_padre: string | null;
  cod_menu_root: string;
  perfiles: IPerfilMenuAsignado[];
}

export interface IDataGridMenuPermission {
  count: number;
  data: IMenuPermisionRow[];
  draw: string | number | null;
  recordsFiltered: number;
  recordsTotal: number;
}

export interface IPadreValidado {
  cod_menu: string;
  nombre_menu: string;
  activo_arbol: string;
  accion: string;
}

export interface IValidacionPadre {
  menu_encontrado: boolean;
  cod_menu: string;
  nombre_menu: string;
  tiene_padre: boolean;
  cod_menu_padre: string | null;
  nombre_menu_padre: string | null;
  padre_habilitado: boolean;
  padres: IPadreValidado[];
}

export interface IMenuPermisionChangeResponse {
  puxam_id: string;
  puxam_perid: string;
  puxam_codmenu: string;
  puxam_clienteid: string;
  puxam_activo: string;
  validacion_padre: IValidacionPadre;
}

export interface IMenuPermisionBulkItem {
  puxam_id: string | number;
  puxam_codmenu: string;
  puxam_perid: number;
  puxam_clienteid: string | number;
  puxam_activo: number;
}

export interface IMenuPermisionBulkError {
  statusCode: number;
  msg: string;
  detail?: string;
}

export interface IMenuPermisionBulkResultado {
  indice: number;
  cod_menu: string;
  ok: boolean;
  data?: unknown;
  error?: IMenuPermisionBulkError;
}

export interface IMenuPermisionBulkResponse {
  success: boolean;
  total: number;
  exitosos: number;
  fallidos: number;
  resultados: IMenuPermisionBulkResultado[];
}

export interface IMenuLink {
  name: string;
  code: string;
  parentCode: string | null;
  url: string;
  icon: string | null;
  active: string;
  key: string;
  classname: string | null;
  automationid: string | null;
  iconProps: string | null;
  links?: IMenuLink[];
}

export interface IMenuGroup {
  links: IMenuLink[];
}

export class MenuPermissionSystem {
  private readonly base = "/perfil-usuario-arbol-menu-cliente";

  constructor(private requestHandler: XhrRequestHandler) {}

  async getDataMenuPermission(clientId: string): Promise<IDataGridMenuPermission> {
    return await this.requestHandler.get<IDataGridMenuPermission>(`${this.base}/datagridPerfilUsuarioArbolMenuCliente/${clientId}`);
  }

  async getListPerfiles(): Promise<IPerfil[]> {
    return await this.requestHandler.get<IPerfil[]>(`${this.base}/listPerfiles`);
  }

  async changeMenuPermission(data: IMenuPermsssion): Promise<IMenuPermisionChangeResponse> {
    return await this.requestHandler.post<IMenuPermisionChangeResponse, IMenuPermsssion>(`${this.base}`, data);
  }

  async saveMenuPermissionsBulk(data: IMenuPermisionBulkItem[]): Promise<IMenuPermisionBulkResponse> {
    return await this.requestHandler.post<IMenuPermisionBulkResponse, IMenuPermisionBulkItem[]>(`${this.base}/bulk`, data);
  }

  async getListClients (): Promise<ICliente> {
    return await this.requestHandler.get<ICliente>(`${this.base}/listClients`);
  }

  async getMenuService(): Promise<IMenuGroup[]> {
    return await this.requestHandler.get<IMenuGroup[]>(`${this.base}/menu-controller`);
  }

  async getListMenusInactivos(): Promise<IMenuInactivo[]> {
    return await this.requestHandler.get<IMenuInactivo[]>(`${this.base}/listMenusInactivos`);
  }
}
